export default "__VITE_ASSET__CGSH539v__"